import React, { useState } from 'react';
import { WrappedFieldProps } from 'redux-form';

import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { IconButton, InputAdornment, makeStyles } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

type IPasswordFieldComp = WrappedFieldProps & TextFieldProps;

const useStyles = makeStyles({
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export const PasswordFieldComp = ({ input, meta, ...rest }: IPasswordFieldComp) => {
  const [showPassword, setShowPassword] = useState(false);
  const classes = useStyles();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      fullWidth
      {...input}
      {...rest}
      type={showPassword ? 'text' : 'password'}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" style={{ position: "absolute", top: "15px", right: "10px" }}>
            <IconButton
              className={classes.iconButton}
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordFieldComp
